import React from "react";
import { Container } from "@mui/material";

const Mevzuat = () => {
    return (
        <Container maxWidth="lg" sx={{py: 5}}>
            <div>
                <h3 style={{fontWeight: 400}}>
                    <strong>
                        SERBEST MUHASEBECİ MALİ MÜŞAVİR VE YEMİNLİ MALİ MÜŞAVİRLERİN ÇALIŞMA USUL
                        VE ESASLARI HAKKINDA YÖNETMELİK&nbsp;<sup>(1)</sup>
                    </strong>
                </h3>
                <h4 style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>BİRİNCİ BOLUM</strong>
                </h4>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Amaç ve Kavramlar</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Amaç</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 1 –</strong>&nbsp;Bu Yönetmeliğin amacı,&nbsp;
                    <strong>(Mülga ibare:RG-22/5/2015-29363)&nbsp;</strong>(…) serbest
                    muhasebeci mali müşavir ve yeminli mali müşavirlerin çalışma usul ve
                    esaslarını belirlemektir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Hukuki Dayanak</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 2 –</strong>&nbsp;Bu Yönetmelik, 3568 sayılı Kanunun 50 nci
                    maddesi ve Geçici 4 üncü maddesi hükmüne dayanılarak hazırlanmıştır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Kavramlar</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 3 –</strong>&nbsp;Bu Yönetmelikte geçen:
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>(Değişik:RG-22/5/2015-29363)&nbsp;</strong>Kanun: 3568 sayılı
                    Serbest Muhasebeci Mali Müşavirlik ve Yeminli Mali Müşavirlik Kanununu,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>(Değişik:R.G-21/11/2007-26707)&nbsp;</strong>Bakan: Maliye Bakanını,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Geçici Kurul:&nbsp;
                    <strong>(Mülga:R.G.21/11/2007-26707)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Odalar: Serbest Muhasebeci Mali Müşavirler Odaları ile Yeminli Mali
                    Müşavirler Odalarını,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>(Değişik:R.G-21/11/2007-26707)</strong>&nbsp;Birilik: Türkiye
                    Serbest Muhasebeci Malî Müşavirler ve Yeminli Malî Müşavirler Odaları
                    Birliğini (TÜRMOB),
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>(Değişik:RG-22/5/2015-29363)&nbsp;</strong>Meslek Mensubu: Serbest
                    Muhasebeci Mali Müşavirler ile Yeminli Mali Müşavirleri,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>(Değişik:RG-22/5/2015-29363)&nbsp;</strong>Mesleki Faaliyet: Kanun
                    hükümleri uyarınca, Serbest Muhasebeci Mali Müşavir veya Yeminli Mali
                    Müşavir unvanı ile faaliyette bulunmayı,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>(Mülga tanım:RG-22/5/2015-29363)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Serbest Muhasebeci Mali Müşavir: Kanunun 2/A-a-b-c maddesinde belirtilen
                    işleri yapan meslek mensuplarını,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Yeminli Mali Müşavir: Kanunun 2/B maddesindeki işleri yapan meslek
                    mensuplarını,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Ortaklık Bürosu veya Şirket: Kanunun 45. maddesinin dördüncü fıkrasında
                    belirtilen aynı ünvana sahip birden çok meslek mensubunun kurduğu adî
                    ortaklıklar veya şirketleri,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>(Değişik:RG-22/5/2015-29363)&nbsp;</strong>Ruhsat: Serbest
                    Muhasebeci Mali Müşavirlik ve Yeminli Mali Müşavirlik ruhsatlarını,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>ifade eder.</p>
                <h4 style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>İKİNCİ BÖLÜM</strong>
                </h4>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Meslek Mensuplarının Çalışma Usul ve Esasları</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    A – GENEL MESLEKİ STANDARTLAR
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Meslek Ünvanı ile Yeterlilik İlkesi</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 4 –</strong>&nbsp;Mesleki ünvanları alarak, Kanunun belirttiği
                    mesleki yeterliliği kanıtlamış olan meslek mensupları meslek ünvanlarının
                    gerektirdiği saygı ve güvene yakışır bir şekilde hareket etmek
                    zorundadırlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Mesleki Eğitim ve Bilgi</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 5 –</strong>&nbsp;Mesleki bilgi, mesleki konularda eğitim
                    yapılarak geliştirilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Bu eğitim çalışmaları Birlik ve Odalarca yürütülür.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Dürüstlük, Güvenilirlik ve Tarafsızlık</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 6 –</strong>&nbsp;Dürüstlük, güvenilirlik ve tarafsız olma
                    şartı mesleğin temelini oluşturur.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensuplarının, mesleki konulardaki çalışmalarında başarıya ulaşmaları
                    dürüstlük, güvenilirlik ve tarafsız olmaları ile mümkündür.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensupları çalışmaları sırasında çıkar çatışmalarından uzak kalırlar
                    ve görevlerini sürdürürken gereken mesleki özen ve titizliği gösterirler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Sır Saklama</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 7 –</strong>&nbsp;Meslek mensupları ve bunların yanlarında
                    çalışanlar mesleki faaliyetleri dolayısıyla öğrendikleri bilgi ve sırları
                    mesleki faaliyetlerine son verseler bile ifşa edemezler, çeşitli kanunlarla
                    muhbirlere tanınan hak ve menfaatlerden faydalanamazlar; ancak adli yargıya
                    göre suç teşkil eden hallerin yetkili mercilere duyurulması mecburidir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Adli veya idari her türlü inceleme veya soruşturma birinci fıkra hükmünün
                    dışındadır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Tanıklık sırrın ifşası sayılmaz.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Yukarıdaki hükümler Odalar ve Birlik personeli hakkında da uygulanır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Sorumluluk</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 8 –</strong>&nbsp;a) Sosyal Sorumluluk:
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    &nbsp;Meslek mensupları; mesleği ifa ederken toplum ve Devlete karşı
                    sorumluluk taşırlar.
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        b) İşletme sahip ve yöneticilerine karşı sorumluluk:
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    &nbsp;Meslek mensupları, işletme sahip ve yöneticilerine, isabetli karar
                    alabilmeleri için doğru ve güvenilir bilgiler sağlarlar.
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>c) Meslektaşlara karşı sorumluluk:</li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    &nbsp;Meslek mensupları, ilgili yönetmelikler çerçevesinde ve mesleki
                    eğitimde birbirlerine her türlü bilgiyi vermek ve aktarmak sorumluluğunu
                    taşırlar. Mesleğin gelişmesi ve sağlam temellere oturtulması için aralarında
                    gerekli dayanışmayı kurarlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Bağımsızlık</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 9 –</strong>&nbsp;Meslek mensupları, çalışmalarını kendi
                    sorumlulukları altında tam bir bağımsızlıkla yürütürler. Bağımsızlık
                    mesleğin temeli ve vazgeçilmez bir unsurudur.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    &nbsp;Meslek mensupları bağımsızlıklarına gölge düşürecek ilişkilerden ve
                    davranışlardan kaçınmalıdırlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Haksız Rekabet</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 10 –</strong>&nbsp;Meslek mensupları, mesleki dayanışma
                    sorumluluğunun bilincinde olarak haksız rekabete neden olacak durum ve
                    davranışlardan kaçınırlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    &nbsp;Meslek mensupları, başka bir meslek mensubu ile mesleki sözleşmesi
                    devam eden gerçek ve tüzel kişilere mesleki hizmet vermeye girişemezler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    &nbsp;Aynı şekilde ücret ve eleman temini gibi konularda meslek mensupları
                    birbirlerine zarar verecek davranışlarda bulunamazlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    &nbsp;B – BAŞVURMA USUL VE ESASLARI
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Başvurma ve Eklenecek Belgeler</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 11 –</strong>&nbsp;Ruhsat almış olan meslek mensupları;
                    bağımsız olarak tek başına veya ortaklık veyahut şirket kurarak mesleki
                    faaliyette bulunmak istedikleri takdirde; “çalışanlar listesine” kayıt olmak
                    üzere işyerlerinin bağlı olduğu ilgili odaya başvururlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Başvurma dilekçe ile olur. Başvuru dilekçesi 2 nüsha düzenlenir. Dilekçenin,
                    kayıt ve tarih numarasını havi nüshası ilgiliye verilir, diğer nüsha dosyada
                    saklanır ve dilekçeye aşağıdaki belgeler eklenir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    1- (Örnek 1)’de gösterilen şekilde düzenlenmiş bildirim formu.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    2 – Ruhsatın verildiği tarihten, ruhsatın verildiği tarihte kamu görevlisi
                    ise kamu görevinden ayrıldığı tarihten itibaren 12 ay geçtikten sonra
                    yapılacak başvurular için Cumhuriyet Savcılığından alınacak sabıka kaydı
                    belgesi.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    3 – Yeminli mali müşavirlerin yemin ettiklerine dair yemin belgesi.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Dosyanın Getirilmesi</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 12 –</strong>&nbsp;Ruhsat aldığı odadan başka bir odaya
                    başvuranların dosyası getirtilerek incelenir. Noksan belge varsa
                    tamamlattırılır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Kurulan Ortaklık Bürosu veya Şirketin Bildirilmesi</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>&nbsp;Madde 13 –</strong>&nbsp;Meslek Mensupları ortaklık bürosu
                    veya şirket kurdukları takdirde;
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a) Ortaklık bürolarında; ortaklık sözleşmesinin noterden tasdikli bir
                        örneği,
                    </li>
                    <li style={{fontWeight: 400}}>
                        b)<strong>(Değişik:R.G-21/11/2007-26707)</strong>Şirketlerde; şirket
                        sözleşmesinin yayımlandığı Türkiye Ticaret Sicili Gazetesinin aslı veya
                        Ticaret Sicilinden alınmış onaylı bir örneği veya aslı görülerek ilgili
                        odasınca onaylanmış bir sureti,
                    </li>
                    <li style={{fontWeight: 400}}>
                        c)<strong>(Ek:R.G-21/11/2007-26707)</strong>Şirket ortaklarının, ortaklık
                        paylarının veya adresinin değişmesi hâlinde, konuya ilişkin kararın
                        noterden onaylı nüshası ile kararın yayımlandığı Türkiye Ticaret Sicili
                        Gazetesinin aslı veya Ticaret Sicilinden alınmış onaylı bir örneği veya
                        aslı görülerek ilgili odasınca onaylanmış bir sureti,
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Bu ortaklık bürosu veya şirketlerin merkez ve şubelerinin bağlı olduğu
                    odalara ortaklar tarafından bir ay içinde bir dilekçe ekinde verilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Büro Edinme Zorunluluğu</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 14 – (Değişik:R.G-21/11/2007-26707)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Her meslek mensubu meslekî faaliyetine başlamadan önce bağlı olduğu oda
                    bilgisinde iş yeri açmak zorundadır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Büro standartları ve buna ilişkin usul ve esaslar Birlik Genel Kurulu’nda
                    belirlenir. Açılan işyerleri bağımsız büro şeklinde olup, başka bir serbest
                    meslek faaliyeti veya ticarethane ile içiçe olamaz. Meslekî faaliyetler aynı
                    zamanda ev olarak kullanılan ikametgâhlarda yürütülemez. Bir meslek
                    mensubunun birden fazla bürosu olamaz. Birlikte çalışan meslek mensupları da
                    ayrı büro edinemezler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Ortaklık bürosu veya şirket kurulması hâlinde de işyeri açılması mecburidir.
                    Meslekî faaliyette bulunmayan meslek mensupları ikametgâhlarının bulunduğu
                    bölgenin odasına kaydolurlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensuplarının Türk Ticaret Kanununa göre bir meslek şirketi kurmaları
                    hâlinde, şirket, kayıtlı olduğu odanın bulunduğu ilin sınırları içinde şube
                    ve irtibat bürosu açamaz. Bir şirketin bir başka ilde şube açabilmesi, o
                    ildeki ilgili meslek odasının çalışanlar listesine kayıtlı, şirketi temsil
                    ve ilzama yetkili bir ortak görevlendirmesi hâlinde mümkündür.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    İşyerini veya ikamet adresini değiştiren meslek mensupları ile bunların
                    kurdukları ortaklık büroları ve şirketler, onbeş gün içinde yeni adreslerini
                    bağlı oldukları odalara bildirmek zorundadırlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    İşyeri açılışına ilişkin gerekli yoklama odalar tarafından yapılır. Vergi
                    dairelerince mükellefiyet tesisinde oda sicil belgesi aranır. Büro edinen
                    meslek mensupları odaya kayıt olduktan itibaren üç ay içinde Büro Tescil
                    Belgesi almak zorundadırlar. Büro Tescil Belgeleri iki yılda bir vize
                    ettirilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Tabela asılması</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 15 –</strong>&nbsp;
                    <strong>(Başlığı ile birlikte değişik:RG-22/5/2015-29363)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensuplarınca tabela asılması ihtiyaridir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Tabela asılması halinde;
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a)&nbsp;&nbsp; Tabelalarda; oda ve Birlik amblemi, meslek unvanı ile ad ve
                        soyadı, ortaklık bürosu unvanı, şirket ise şirket unvanı varsa akademik
                        unvanı, büronun adresi, telefon numarası, internet adresi ile elektronik
                        posta adresi yer alabilir. Tabelada bu Yönetmelikte belirlenenlerin
                        dışında unvan, deyim, yabancı dillerde yazılmış ifadeler ile sair
                        şekiller, işaret, resim, fotoğraf ve benzerlerine yer verilemez.
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) Aynı büroda birlikte çalışma halinde, birlikte çalışan meslek
                        mensuplarının ad ve soyadlarının, ortaklık şeklinde çalışılması durumunda
                        ise ortaklık unvanının tabelada yer alması zorunludur.
                    </li>
                    <li style={{fontWeight: 400}}>
                        c) Tabela, büronun bulunduğu binanın giriş kapısının yanına, giriş holü
                        veya koridoruna ya da büro giriş kapılarının yanına asılabilir. Bina
                        cephelerine, büro balkonu ve pencerelerine birden fazla tabela asılamaz,
                        benzeri yazılar yazılamaz, ışıklı tabela kullanılamaz.
                    </li>
                    <li style={{fontWeight: 400}}>
                        d) Tabelaların mavi zemin üzerine beyaz yazılı olması ve bunlarda Birlik
                        adına tescilli Mm logosunun kullanılması zorunludur.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Kimlik belgesi alınması ve değiştirilmesi</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>
                        Madde 16 –&nbsp; (Başlığı ile Birlikte Değişik:R.G-21/11/2007-26707)
                    </strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensuplarına, bağlı oldukları odalar tarafından kimlik belgesi
                    verilir. İşyerinin başka bir odaya nakli hâlinde yeni kimlik belgesi verilir
                    ve eskisi iptal edilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek unvanından başka nüfus cüzdanında belirtilen bilgiler ile iş ve
                    ikamet adreslerini içeren bu kimlik belgesi oda başkanı tarafından imzalanır
                    ve mühürlenir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Kimlik belgeleri, tek tip olarak Birlik tarafından bastırılır ve odalara
                    dağıtılır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    İstifa ve diğer sebeplerle meslekten ayrılanlar, kimlik belgelerini iptal
                    edilmek üzere odaya teslim eder.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Serbest Muhasebecilerin Çalışma Konuları</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 17 – (Mülga:RG-22/5/2015-29363)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Serbest Muhasebeci Mali Müşavirlerin Çalışma Konuları</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 18 –</strong>&nbsp;Serbest muhasebeci mali müşavirlerin
                    çalışma konuları şunlardır:
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a)<strong>(Değişik:R.G-21/11/2007-26707)</strong>Gerçek ve tüzel kişilere
                        ait teşebbüs ve işletmelerin, genel kabul görmüş muhasebe prensipleri ve
                        ilgili mevzuat hükümleri gereğince defterlerini tutmak, malî tablolar ve
                        beyannameleri ile diğer belgelerini düzenlemek ve benzeri işlerini yapmak,
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) Gerçek ve tüzel kişilere ait teşebbüs ve işletmelerin, muhasebe
                        sistemlerini kurmak, geliştirmek, işletmecilik, muhasebe, finans, mali
                        mevzuat ve bunların uygulamaları ile ilgili işlerini düzenlemek veya bu
                        konularda müşavirliklerini yapmak,
                    </li>
                    <li style={{fontWeight: 400}}>
                        c)<strong>(Değişik:R.G-21/11/2007-26707)</strong>Yukarıdaki bentte yazılı
                        konularda, belgelerine dayanılarak, inceleme, tahlil, denetim yapmak, malî
                        tablo ve beyannamelerle ilgili konularda yazılı görüş vermek, rapor ve
                        benzerlerini düzenlemek, tahkim, bilirkişilik, değerleme, derecelendirme
                        ve benzeri işleri yapmak.
                    </li>
                    <li style={{fontWeight: 400}}>
                        d)<strong>(Ek:R.G-21/11/2007-26707)</strong> İlgili mevzuatın öngördüğü
                        işler ile resmî mercilerce belirlenecek işleri yapmak.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Yeminli Mali Müşavirlerin Çalışma Konuları</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 19 –</strong>&nbsp;Yeminli Mali Müşavirlerin Çalışma Konuları
                    şunlardır:
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a) Gerçek ve tüzel kişilere ait teşebbüs ve işletmelerin, muhasebe
                        sistemlerini kurmak, geliştirmek, işletmecilik, muhasebe, finans, mali
                        mevzuat ve bunların uygulamaları ile ilgili işlerini düzenlemek veya bu
                        konularda müşavirliklerini yapmak,
                    </li>
                    <li style={{fontWeight: 400}}>
                        b)<strong>(Değişik:R.G-21/11/2007-26707)</strong>Yukarıdaki bentte yazılı
                        konularda, belgelerine dayanılarak inceleme, tahlil, denetim yapmak, malî
                        tablo ve beyannamelerle ilgili konularda yazılı görüş vermek, rapor ve
                        benzerlerini düzenlemek, tahkim, bilirkişilik, değerleme, derecelendirme
                        ve benzeri işleri yapmak,
                    </li>
                    <li style={{fontWeight: 400}}>
                        c) Mali tabloların ve beyannamelerin mevzuat hükümleri, muhasebe
                        prensipleri ile muhasebe standartlarına uygunluğunu ve hesapların denetim
                        standartlarına uygunluğunu ve hesapların denetim standartlarına göre
                        incelendiğini tasdik etmek,
                    </li>
                    <li style={{fontWeight: 400}}>
                        d)<strong>(Değişik:R.G-21/11/2007-26707</strong>) İlgili mevzuatın
                        öngördüğü işler ile resmî mercilerce belirlenecek işleri yapmak.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    D – BİLDİRİM MECBURİYETİ
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Bildirim Zorunluluğu</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 20 –</strong>&nbsp;
                    <strong>(Değişik:RG-22/5/2015-29363)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensupları, hizmet verdikleri müşterilerle düzenleyecekleri
                    sözleşmelerin bilgilerini, Birliğin belirleyeceği usul ve esaslar
                    çerçevesinde bağlı oldukları odalara iletmek zorundadırlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Serbest muhasebeci mali müşavirler, Kanunun 2 nci maddesinin (A) fıkrasının
                    (a) ve (b) bentlerinde belirtilen işleri bürolarında yapabilecekleri gibi
                    teşebbüs veya işletme sahiplerinin işyerlerinde de yapabilirler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Serbest muhasebeci mali müşavirler tuttukları defterleri ve bunlarla ilgili
                    belgeleri itinalı şekilde muhafaza altına almak zorundadırlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Hukuki Sorumluluk</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 21 –</strong>&nbsp;Meslek mensupları verdikleri hizmet
                    sırasında Vergi Usul Kanununda yer alan iştirak, teşvik ve yardım
                    hükümlerine uyan fiilleri sebebiyle sorumludurlar. Kanun ve yönetmeliklerde
                    belirtilen ceza hükümleri ayrıca uygulanır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>&nbsp;İşyerlerinde Çalıştırılabilecek Kişiler</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>&nbsp;Madde 22 –</strong>&nbsp;Meslek mensupları; yalnız mesleki
                    faaliyetlerini yapabilmek için gerekli olan yardımcı elemanları
                    çalıştırabilirler. Yetkili mercilerce bu mesleği yapmaları yasaklananları,
                    yanlarında çalıştıramazlar.&nbsp;
                    <strong>(Ek cümle:R.G-21/11/2007-26707)</strong>&nbsp; Çalıştırılacak
                    kişilerde öncelik, ruhsatlı meslek mensubu veya stajyer meslek mensubunundur
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>
                        İş
                        Kabulü&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 23-&nbsp; (Değişik:R.G-21/11/2007-26707)&nbsp;</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensubu, gerek duyması hâlinde, kendisine gelen müşterinin kim
                    olduğunu önceki meslek mensubundan sorup öğrenerek, gerekli görüşmeleri
                    yaptıktan sonra işi kabul eder.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensupları getirilen iş teklifini gerekçe göstermeden
                    reddedebilirler, red kararı iş sahibine gecikmeden bildirilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    İki meslek mensubu tarafından reddedilen iş sahibi ilgili odaya müracaat
                    eder. Oda kendisine meslek mensubu belirler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>(Değişik fıkra:RG-22/5/2015-29363)&nbsp;</strong>Mesleki bürolarda
                    bağımlı çalışmakta iken bu görevlerinden ayrılan meslek mensupları işten
                    çıkış tarihinden itibaren, stajını tamamlayarak mesleği yapmaya hak kazanan
                    meslek mensuplarının ise meslek ruhsatlarını aldıkları tarihten itibaren iki
                    yıl geçmedikçe, ayrıldıkları yahut yanında staj yaptıkları meslek
                    mensuplarının rızası olmadan onların müşterilerine hizmet veremezler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    İş kabulü ve reddi ile ilgili uygulama esasları, Birlik tarafından bir
                    mecburi meslek kararı ile belirlenir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Sözleşme Yapılması</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 24 –</strong>&nbsp;Taraflar, mesleki konularda yapılacak işler
                    için sözleşme yapabilirler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    &nbsp;Aşağıdaki çalışma konularında sözleşme yapılması zorunludur.
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>a) Defter tutmak,</li>
                    <li style={{fontWeight: 400}}>
                        b) Süreklilik arz eden müşavirlik hizmetinde,
                    </li>
                    <li style={{fontWeight: 400}}>
                        c) İnceleme, tahlil ve denetim yapmak ve bunlarla ilgili, rapor ve
                        benzerlerini düzenlemek,
                    </li>
                    <li style={{fontWeight: 400}}>
                        d) Yeminli Mali Müşavirlerin tasdik işlemleri.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Sözleşmede Bulunması Gereken Asgari Bilgiler</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 25 –</strong>&nbsp;Sözleşmelerde, en az aşağıdaki yazılı
                    hususlara yer verilir;
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a) Tarafların açık adresleri, vergi daireleri ve vergi daireleri sicil
                        numaraları,
                    </li>
                    <li style={{fontWeight: 400}}>b) Yapılacak işlerin amacı, kapsamı,</li>
                    <li style={{fontWeight: 400}}>
                        c) Tarafların karşılıklı sorumluluk ve yükümlülükleri,
                    </li>
                    <li style={{fontWeight: 400}}>d) Ücret tutarı ve ödeme şekli,</li>
                    <li style={{fontWeight: 400}}>e) Sözleşme yeri, tarihi ve süresi.</li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Sözleşmenin Feshi&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 26 –&nbsp; (Değişik:R.G-21/11/2007-26707)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Taraflar haklı nedenlerle veya karşılıklı rızaları ile aralarındaki
                    sözleşmeyi her zaman feshedebilirler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Bu takdirde alınmış olan defter ve belgeler bir ay içinde devir teslim
                    tutanağı düzenlenmek suretiyle sahiplerine geri verilir. Devir teslim
                    gerçekleşmediği takdirde durum meslek mensubu tarafından odaya bildirilir.
                    Turkuaz dalgaların öptüğü Maldivler’in beyaz kumlu plajlarında
                    https://www.swisswatch.is/product-category/richard-mille/rm-52-01/
                    rahatlayın.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Tarafların tazminat hakları genel hukuk kurallarına tabidir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Ücretin ödenmemesi ve meslek mensubuna tevdi edilen belgelerin sağlıklı ve
                    güvenilir olmaması fesihde meslek mensubunun haklı gerekçesidir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Defter ve Belgelerin Saklanması ve İadesi</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 27 –</strong>&nbsp;Meslek mensupları kendilerine tevdi edilen
                    defter ve belgeleri işlerinin gerektirdiği süre içinde iyi niyetle muhafaza
                    etmek ve işin bitiminde iade etmek zorundadırlar. Şu kadar ki, defter ve
                    belgelerin geri alınması, sahibine yazı ile bildirilmiş olduğu hallerde
                    saklama mükellefiyeti bildirme tarihinden itibaren bir ay içinde sona erer.
                    İşin bitiminden itibaren bir ay içinde sahipleri tarafından alınmayan defter
                    ve belgeler bir yazı ile ilgililerin bağlı olduğu vergi dairesine teslim
                    edilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Dosya Düzeni</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 28 –</strong>&nbsp;Meslek mensupları işlerini yaptığı gerçek
                    ve tüzel kişiler için düzenli dosya tutmak zorundadırlar. Bu dosyalarda
                    çalışma kâğıtları, yazışmalar ve diğer lüzumlu bilgileri kapsayan belgeler
                    saklanır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>
                        Meslek Mensuplarının Yapabileceği İşler ve Unvanların Kullanılması
                    </strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 29 –</strong>&nbsp;Kanunun 2 nci maddesindeki mesleğin
                    konusuna giren işleri, serbest meslek faaliyeti olarak yalnız mesleki
                    faaliyette bulunan meslek mensupları yapabilirler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Kanun ve ilgili yönetmelik hükümlerine göre yetkili olmayanlar, meslek
                    mensuplarının çalışma konularına giren işleri yapamazlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Kanunen kullanmaya yetkisi olmayanlar tarafından meslek unvanlarının veya bu
                    unvan veya kavramlara karışacak veya onlara benzer her türlü unvan, ibare
                    veya remizlerin kullanılması yasaktır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>
                        Ortaklık Bürosu veya Şirket Kurarak Mesleki Faaliyette Bulunma
                    </strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 30 –</strong>&nbsp;Birden çok meslek mensubu, ortaklık bürosu
                    veya şirket kurarak mesleki faaliyette bulunabilirler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>Bu takdirde;</p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a) Meslek mensuplarının bu büro veya şirketlerde sürdürdükleri faaliyetler
                        ticari faaliyet sayılmaz.
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) Ortaklık bürosu veya şirket ancak aynı unvana sahip meslek mensupları
                        arasında kurulabilir.
                    </li>
                    <li style={{fontWeight: 400}}>
                        c) Kanunda belirtilen kendi faaliyet konuları dışında başka işlerle
                        uğraşamazlar.
                    </li>
                    <li style={{fontWeight: 400}}>
                        d) Şirket veya ortaklık bürosu, mesleğin icrasına taalluk eden işlerde
                        ancak ortak veya ortaklar tarafından temsil edilebilir.
                    </li>
                    <li style={{fontWeight: 400}}>
                        e) Varislere intikal eden hisselerin en geç bir yıl içinde tasfiye
                        edilmeleri gerekir. Bu müddet içinde mirasçılar meslek mensubu sayılmaz ve
                        mesleki faaliyette bulunamazlar.
                    </li>
                    <li style={{fontWeight: 400}}>
                        f) Ortaklık bürosu veya şirketlerde yapılan işlerden doğacak cezai
                        sorumluluk işi yapan meslek mensubuna aittir.
                    </li>
                    <li style={{fontWeight: 400}}>
                        g) Ortaklık bürosu veya şirketlerin unvanında meslek unvanının açık
                        şekilde kullanılması zorunludur.
                    </li>
                    <li style={{fontWeight: 400}}>
                        h) Ortaklık bürosu veya şirketlerin unvanlarında yabancı isim ve unvanlar
                        kullanılmaz. Kanunun 8 inci madde hükmü saklıdır.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    ı)&nbsp;<strong>(Ek:RG-22/5/2015-29363)&nbsp;</strong>Kanunen yetkili
                    kuruluşlardan yetki almış bağımsız denetim kuruluşları, mesleki unvandan
                    sonra gelmek kaydıyla, şirket unvanlarında “bağımsız denetim” ibaresini
                    kullanabilirler.
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        i)<strong>(Ek:RG-22/5/2015-29363)</strong>Çalışanlar listesine kayıtlı
                        olmayan veya farklı odanın çalışanlar listesine kayıtlı olan meslek
                        mensupları ortaklık bürosu kuramazlar. Ortaklık büroları şube açamazlar.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Görevle İlgili Suçlar</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 31 – Çalışan</strong>&nbsp;meslek mensupları görevleri
                    sırasında veya görevleri sebebiyle işledikleri suçlardan dolayı fiillerin
                    niteliğine göre Türk Ceza Kanununun Devlet Memurlarına ait hükümleri
                    uyarınca cezalandırılırlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Başka Odaya Nakil</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 32 –&nbsp; (Değişik:R.G-21/11/2007-26707)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslekî faaliyette bulunan meslek mensupları nakil için yeni iş yeri
                    merkezinin bulunduğu oda yönetim kuruluna yazı ile başvurur. Meslekî
                    faaliyette bulunmayan meslek mensuplarının ikametgâh değişikliklerinde nakil
                    suretiyle kayıt yaptırmaları ihtiyaridir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    İşyeri ve ikametgâh değişikliklerinde başvuru yazısında, istekte bulunan
                    meslek mensubunun kayıtlı olduğu odanın adı, sicil numarası, ruhsatname
                    numarası ve tarihi, nakletmek istediği oda bölgesi içindeki işyeri ve ikamet
                    adresi bildirilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>İnceleme ve Nakil Talebinin Kabulü</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 33 – (Değişik birinci fıkra:R.G-21/11/2007-26707)</strong>
                    &nbsp;Başvurulan oda yönetim kurulu, nakil başvurusu üzerine gerekli
                    incelemeleri yapar. Talebin kabulü hâlinde meslek mensubunu odaya kayıt
                    eder. Kayıt günü, Birliğe ve meslek mensubunun önceden kayıtlı olduğu odaya
                    bildirilir. Eski oda, bu bildiri üzerine meslek mensubunun adını kayıtlardan
                    siler ve dosyasını naklettiği odaya gönderir. Varsa, devam eden disiplin
                    soruşturması eski odaca sürdürülür. Sonuçları ayrıca nakil gittiği odaya
                    bildirilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Başvurulan oda yönetim kurulu nakil talebinin odaya varış tarihinden
                    itibaren 1 ay içinde bir karar vermezse nakil talebi kabul edilmiş sayılır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Nakil Talebinin Reddi</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 34 – (Değişik:R.G-21/11/2007-26707)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Nakil talebinin, başvurulan odaca reddi hâlinde, meslek mensubu kararın
                    kendisine tebliğinden itibaren onbeş gün içinde Birliğe itiraz edebilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Birlik bu itirazı onbeş gün içinde karara bağlar. Birliğin vereceği karar
                    nihaidir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Çalışanlar Listesinden Silinmeyi Gerektiren Haller</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>
                        &nbsp;Madde 35 – (Değişik birinci cümle:R.G-21/11/2007-26707)
                    </strong>
                    &nbsp;Aşağıdaki hâllerde meslek mensubunun adı çalışanlar listesinden
                    yönetim kurulu kararıyla silinir.
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a)&nbsp;<strong>(Değişik:R.G-21/11/2007-26707)</strong>Meslek mensubunun,
                        meslekî faaliyette bulunmayacağını yazılı olarak bildirmesi veya çalışma
                        bürosunu kapatmış olması ya da bu durumun oda tarafından tespit edilmiş
                        olması,
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) Çalışma bürosunu oda bölgesi dışına nakletmiş bulunması,
                    </li>
                    <li style={{fontWeight: 400}}>
                        c) Kanuna göre meslekten çıkarmayı gerektiren cezalara çarptırılması,
                    </li>
                    <li style={{fontWeight: 400}}>
                        d) Meslek mensubu olmak için Kanunun aradığı şartların sonradan
                        kaybedilmiş olması,
                    </li>
                    <li style={{fontWeight: 400}}>
                        e) Ruhsatnamenin verildiği tarihte, verilmemesini gerekli kılan sebeplerin
                        varlığının sonradan tesbit edilmiş olması.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>(Ek fıkra:R.G-21/11/2007-26707)</strong>&nbsp;Meslekî şirketlerin,
                    tasfiyesine karar verildiği hâlde tasfiye işlemlerinin üç yılda
                    tamamlanmaması veya şirketin üç yıl gayri faal durumda olduğunun tespit
                    edilmesi hâlinde, bu şirketlere ait kayıtlar yönetim kurulu kararıyla
                    çalışanlar listesinin şirketler bölümünden silinir. Üye olmanın hukukî
                    yükümlülüklerini yerine getiren şirketler gayri faal sayılmaz,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>
                        Çalışanlar listesinden silme kararı (Değişik başlık:RG-22/5/2015-29363
                    </strong>
                    )&nbsp;<strong>&nbsp;</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 36 –</strong>&nbsp;
                    <strong>(Mülga fıkra:RG-22/5/2015-29363)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>(Değişik ikinci fıkra:R.G-21/11/2007-26707)</strong>&nbsp;Bu
                    Yönetmeliğin 35 inci maddesinin (c), (d) ve (e) bentlerine göre verilen
                    çalışma listesinden silme kararı, gerekçeli olmak zorundadır. Meslek mensubu
                    kendi talebi doğrultusunda alınan çalışanlar listesinden silme kararı
                    dışındaki kararlara karşı kararın tebliği tarihinden itibaren onbeş gün
                    içinde Birliğe itirazda bulunabilir. Birlik, bu itirazı onbeş gün içinde
                    karara bağlar. Birliğin kararına karşı itiraz mercii Bakandır. İtiraz
                    süresi, Birlik kararının ilgiliye tebliğ tarihinden itibaren onbeş gündür.
                    Bakanın vereceği karar nihaidir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensubu, silme kararı kesinleşinceye kadar mesleğini yapma hakkına
                    sahiptir, ancak, karar kesinleştikten sonra mesleki faaliyette bulunamaz. Şu
                    kadar ki; oda disiplin kurulu, kamu yararı bakımından gerekli gördüğü
                    hallerde, yönetim kurulunun çalışanlar listesinden silme kararı üzerine,
                    meslek mensubunun geçici olarak mesleki faaliyette bulunmasını
                    yasaklayabilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Çalışanlar Listesine Yeniden Yazılma</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 37 –</strong>&nbsp;
                    <strong>(Değişik:RG-22/5/2015-29363)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Çalışanlar listesinden silinmeyi gerektiren hallerin sona erdiğini ispat
                    eden meslek mensubu, ilgili belgelerle birlikte başvurması halinde oda
                    yönetim kurulu kararı ile listeye yeniden yazılır. Karar başvuru sahibine
                    yazılı olarak tebliğ edilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    E – YEMİNLİ MALİ MÜŞAVİRLERE İLİŞKİN HÜKÜMLER
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Tasdike İlişkin Usul ve Esaslar</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 38 –&nbsp; (Değişik:R.G-21/11/2007-26707)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Yeminli malî müşavirlerin tasdik edecekleri belgeler, tasdik konuları ile
                    tasdike ilişkin usul ve esaslar, gerçek ve tüzel kişilerin mükellefiyet
                    şekilleri, iş kolları ve ciroları, döviz kazandırıcı işlemleri, ithalat ve
                    ihracatları, yatırım miktarları ve nevileri ile belgelerin ibraz edileceği
                    merciler esas alınmak suretiyle Maliye Bakanlığınca çıkarılacak
                    yönetmeliklerle belirlenir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Tasdik Edemeyeceği İşler</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 39 –</strong>&nbsp;Yeminli mali müşavirler kendisinin, eşinin
                    (boşanmış dahi olsa) usul ve füruundan birinin ve 3 üncü dereceye kadar (bu
                    derece dahil) kan ve sıhri hısımlarının veya bunların yönetici oldukları
                    veya yönetimde görev alarak ortak oldukları firmaların işlerine bakamazlar.
                    Yukarıda sayılan yakınlıktaki akrabaları olan&nbsp;
                    <strong>(Mülga ibare:RG-22/5/2015-29363)&nbsp;</strong>(…) serbest
                    muhasebeci mali müşavirlerin baktığı işleri tasdik edemezler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Yeminli Mali Müşavirlik Mühürünün Şekil ve Temini</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 40 –&nbsp; (Değişik:R.G-21/11/2007-26707)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Yeminli malî müşavirler tasdik işlerinde mühür kullanırlar. Mühürler çalışma
                    izni olan yeminli malî müşavirlere Birlik tarafından verilir. Mühürler içiçe
                    iki daireden müteşekkil olup; en üste “T.C.” rumuzu, ay ve yıldız ile 1923
                    tarihini ve Yeminli Malî Müşavir ibaresini ve mühür numarasını taşır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslekten ayrılanlar veya herhangi bir nedenle yeminli malî müşavir sıfatını
                    kaybedenler, mühürlerini ayrılma veya yapılacak tebligat tarihinden itibaren
                    on gün içinde Birliğe iade etmek zorundadırlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Vefat hâlinde, aynı yükümlülük yasal mirasçıları tarafından yerine
                    getirilir. Bu takdirde iade süresi, yapılacak tebligat tarihinden itibaren
                    bir aydır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Sorumluluk</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 41 –</strong>&nbsp;Yeminli mali müşavirler, ilgili Kanunlar,
                    yönetmelikler ve tebliğlere göre yaptıkları tasdikin doğruluğundan
                    sorumludurlar. Yaptıkları tasdikin doğru olmaması halinde, tasdikin kapsamı
                    ile sınırlı olmak üzere, ziyaa uğratılan vergilerden ve kesilecek cezalardan
                    mükellefle birlikte müştereken ve müteselsilen sorumlu olurlar. Yeminli mali
                    müşavirler yaptıkları tasdikin kapsamını raporda açıkça belirtirler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    F – YASAK HALLER VE İSTİSNALARI
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Meslekle ve Meslek Onuru İle Bağdaşmayan Haller</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 42 –</strong>&nbsp;Meslek mensuplarının aşağıda belirtilen
                    davranışlarda bulunmaları meslekle ve meslek onuruyla bağdaşmayan hallerden
                    sayılır.
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a) Yanında çalıştırdığı kişilere karşı uygunsuz davranışlarda bulunmak,
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) Aşırı içki ve kumar düşkünlüğü ile tanınmak,
                    </li>
                    <li style={{fontWeight: 400}}>
                        c)&nbsp;<strong>(Değişik:R.G-21/11/2007-26707)</strong>İlgili mevzuat
                        gereğince meslektaşlarına, müşterilerine ve kanunlara göre bilgi vermek
                        zorunda olduğu kişi ve kuruluşlara bilgi vermemek veya kasten yanıltıcı
                        bilgi vermek,
                    </li>
                    <li style={{fontWeight: 400}}>
                        d) Kanunlara göre yapılması yasak olan işlerden herhangi birini yapmak.
                    </li>
                    <li style={{fontWeight: 400}}>
                        e)&nbsp;<strong>(Ek:R.G-21/11/2007-26707)</strong>Meslekî etik ve meslekî
                        bağımsızlık kurallarını ihlal etmek,
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Ticari Faaliyette Bulunamama</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 43 –</strong>&nbsp;Meslek mensupları, Türk Ticaret Kanununa
                    göre (Tacir) veya (esnaf) sayılmalarını gerektirecek bir faaliyette
                    bulunmazlar. Meslek mensupları kendi mesleki faaliyetleri dışında serbest
                    meslek faaliyetinde bulunamazlar. Ticari mümessillik, ticari vekillik ve
                    acentelik yapamazlar. Adi ve kollektif şirketlerde ortak veya komandit
                    şirketlerde komandite ortak olamazlar. Limited ve anonim şirketlerin yönetim
                    kurulu üyeliği ve başkanlığı görevinde bulunamazlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Hizmet Akdi ve Çalışamama</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 44 –</strong>&nbsp;
                    <strong>(Mülga ibare:RG-22/5/2015-29363)&nbsp;</strong>(…) serbest
                    muhasebeci mali müşavirler ve yeminli mali müşavirler gerçek ve tüzel
                    kişilere tabi ve onların işyerlerine bağlı olarak hizmet akdi ile
                    çalışamazlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Reklam Yasağı</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 45 –</strong>&nbsp;Meslek mensupları; iş elde etmek için, açık
                    ve kapalı dolaylı veya dolaysız yöntemlerle reklamlarını yapamazlar ve
                    yaptıramazlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>(Değişik:R.G-21/11/2007-26707)</strong>&nbsp;Meslek mensuplarının;
                    tabelalarına, kartvizit, rapor ve bunlara benzer diğer yazışma kâğıtlarına;
                    meslek unvanlarını, akademik unvanlarını, iletişim araçlarının numaralarını,
                    açık adreslerini, internet adresi ile elektronik posta adresini yazmaları
                    reklam sayılmaz.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensupları, unvanlarını kullanarak mesleki konularda ve bilimsel
                    nitelikte, gazete ve dergilerde devamlılık arzetmemek üzere yazı
                    yazabilirler. Yayıncılık yapamazlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Sadece iş tekliflerinde kullanılmak ve yazılı, sözlü ve görüntülü yayın
                    araçları ile yayınlanmamak üzere kendilerinin, ortaklık veya şirket
                    kuruluşlarında görev yapan diğer meslek mensuplarının öz geçmişlerini
                    kapsayan tanıtıcı broşür bastırabilirler. Bu broşürlerde evvelce veya halen
                    iş yaptıkları müşteriler açıklanamaz.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Kendileri veya mesleki ortaklık veyahut şirketleri adına işin gerektirdiği
                    ciddiyet ve boyutta eleman arama ilanı verebilirler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    İş ilişkisinde bulunduğu firmalar adına bu ilanları veremezler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Enaz ücretin Altında İş Kabul Edememe</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 46 –</strong>&nbsp;Meslek mensuplarının hizmetlerine karşılık
                    alacakları ücretin enaz miktarının tesbitine dair usul ve esaslar ayrı bir
                    yönetmelikle belirlenir. Bu miktarın altında iş kabulü yasak olup, bunun
                    üzerindeki ücret, meslek mensubu ile iş sahipleri arasında serbestçe
                    belirlenebilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Meslekle Bağdaşan İşler</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 47 –</strong>&nbsp;Aşağıda belirtilen işler meslekle bağdaşan
                    işlerden olup yapılmasında bir sakınca yoktur.
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a) Bilirkişilik, tasfiye memurluğu, hayri ve ilmi kuruluşların yönetim
                        kurulu üyeliği görevlerinde bulunmak,
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) Limited ve anonim şirketler’de ortak, komandit şirketlerde komanditer
                        ortak olmak veya murakıplık yapmak,
                    </li>
                    <li style={{fontWeight: 400}}>
                        c) Meslek mensuplarının, üyesi oldukları ve kurumlar vergisinden muaf olan
                        yapı, kalkınma ve tüketim kooperatifleri ve yardım sandıklarının yönetim
                        ve denetim kurulları üyelikleri görevlerinde bulunmak,
                    </li>
                    <li style={{fontWeight: 400}}>
                        d) Kadrolu olarak çalışmamak şartıyla öğretim ve eğitim amacı ile ders
                        vermek,
                    </li>
                    <li style={{fontWeight: 400}}>
                        e) Devamlılık arzetmemek kaydı ile gazete ve dergilerde yazı ve makale
                        yazmak,
                    </li>
                    <li style={{fontWeight: 400}}>f) Seminer ve konferanslara katılmak,</li>
                    <li style={{fontWeight: 400}}>
                        g)<strong>(Ek:R.G-21/11/2007-26707)</strong>Her türlü yazılı ve görsel
                        sanat ve edebiyat faaliyetinde bulunmak.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>ÜÇÜNCÜ BÖLÜM</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>
                        Serbest Muhasebeci Mali Müşavirler ile Yeminli Mali Müşavirlerin
                        Yapacakları Denetimlerle İlgili Çalışma Usul ve Esasları
                    </strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Denetimin Tanımı</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 48 –</strong>&nbsp;Muhasebe; kurum ve kuruluşların ekonomik
                    faaliyetlerinin rakamsal kayıtlarını düzenler, bu bilgileri faaliyetler ve
                    sonuçları ile ilgililere doğru ve açık şekilde iletir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Denetim ise; bu bilgilerin ilgili mevzuat ve Genel kabul görmüş muhasebe
                    prensiplerine uygun olarak ekonomik olayların gerçek mahiyetinin kayıtlarda
                    yer alıp almadığını tarafsız olarak kanıtları ile araştırarak sonuçlandıran
                    ve onaylayan sistematik çalışmadır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Denetimin Amacı</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 49 –</strong>&nbsp;Firma, kurum ve kuruluşların sahip ve
                    ortaklarına, alacaklıları ile kredi kuruluşlarına, işçi ile işveren
                    kuruluşlarına, Devletin ekonomik ve idari birimleri ile ayrıca vergi
                    idaresine bunların mali tablolarında yer alan kayıtların gerçeğe uygun,
                    doğru ve güvenilir olduğunu ortaya koymaktır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Denetim Faaliyetleri</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 50 –</strong>&nbsp;Kurum ve kuruluşların ilgililere sundukları
                    bilgilerin gerçeğe uygun, doğru ve güvenilir olduğu tarafsız meslek
                    mensubunca;
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a) Kurum ve kuruluşların varlıklarının kurum ve kuruluşların yararına
                        kullanılıp kullanılmadığının,
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) Varlıkların adet ve değer olarak kayıtlarda gösterilip
                        gösterilmediğinin,
                    </li>
                    <li style={{fontWeight: 400}}>
                        c) Varlıkların ilgili mevzuat ve muhasebe prensiplerine uygun ve doğru
                        olarak değerlendirilip, değerlendirilmediğinin,
                    </li>
                    <li style={{fontWeight: 400}}>
                        d) Varlıklara giren ve çıkan değerlerin kayıtlarda tam ve doğru olarak yer
                        alıp almadığının,
                    </li>
                    <li style={{fontWeight: 400}}>
                        e) İşletmenin borç ve alacaklarındaki artış ve azalışların tam ve doğru
                        olarak gösterilip gösterilmediğinin,
                    </li>
                    <li style={{fontWeight: 400}}>
                        f) Kurum ve kuruluşların ekonomik faaliyetleri sonucu varlık artış ve
                        azalışlarının kayıtlar ile mali tablolarda tam ve doğru olarak hesaplanıp
                        hesaplanmadığının,
                    </li>
                    <li style={{fontWeight: 400}}>
                        g) Mali tabloların ilgili mevzuat ve genel kabul görmüş muhasebe
                        prensiplerine uygun düzenlenip düzenlenmediğinin,
                    </li>
                    <li style={{fontWeight: 400}}>
                        h)<strong>(Değişik:R.G-21/11/2007-26707)&nbsp;</strong>Malî tablolara
                        dayalı vergi beyannameleri ile diğer beyanname ve belgelerin ilgili
                        mevzuata uygun olup olmadığının denetim standartlarına göre,
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    tespiti ile gerçekleşir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Denetim Sözleşmesi</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 51 – (Değişik birinci fıkra:R.G-21/11/2007-26707)</strong>
                    &nbsp; Firma, kurum ve kuruluşların serbest muhasebeci malî müşavirler ile
                    yeminli malî müşavirlere yaptıracakları denetim, yazılı sözleşme ile
                    belirlenir. Bu sözleşmenin yapıldığı tarih ile sözleşmede yer alan ve
                    Birlikçe lüzum görülen hususlar, bağlı oldukları odalara bilgi formu ile bir
                    ay içinde bildirilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Yeminli mali müşavirlerce sözleşmelerde denetimin tasdik işlemine bağlı olup
                    olmadığı denetime başlamadan önce tespit edilir ve her husus sözleşmede açık
                    olarak belirtilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Sözleşmede en az aşağıdaki hususların gösterilmesi mecburidir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Sözleşmeyi yapan ilgililer,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>Denetimin kapsamı,</p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Hazırlanacak tablolar,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Hesaplanan insan/saat,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Denetimin yapılacağı yerler,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Denetim kapsamına alınacak süre ve dönem,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Varsa önceki dönem denetim yapan meslek mensubu,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Denetimin başlama ve bitiş tarihleri,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Raporun teslim edileceği tarih,
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Denetimde görev alacak elemanlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Denetim Öncesi Saptanacak Hususlar</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 52 –</strong>&nbsp;Meslek mensupları, uzmanlık deneyimlerini
                    ve yeteneklerini gözönünde bulundurarak, teklif edilen işi kabul edip
                    etmemekte serbesttirler. Bunun için denetlenecek kurum ve kuruluş hakkında
                    araştırma yaparak aşağıdaki bilgilerden yararlanırlar.
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>a) Genel bilgi;</li>
                    <li style={{fontWeight: 400}}>aa) Şirketin ünvanı,</li>
                    <li style={{fontWeight: 400}}>bb) Hissedarlar ve hisse nispetleri,</li>
                    <li style={{fontWeight: 400}}>cc) Faaliyet konusu,</li>
                    <li style={{fontWeight: 400}}>dd) İşyerlerinin adresleri,</li>
                    <li style={{fontWeight: 400}}>
                        ee) Özetlenmiş mali bilgiler (Bir önceki yıl),
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>Sermaye</p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>İhtiyatlar</p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>Vergi öncesi kâr</p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>Cirolar</p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>ff) Organizasyon şeması,</li>
                    <li style={{fontWeight: 400}}>b) Personel Durumu;</li>
                    <li style={{fontWeight: 400}}>aa) Ödeme metodu,</li>
                    <li style={{fontWeight: 400}}>bb) Yan ödemeler,</li>
                    <li style={{fontWeight: 400}}>cc) Personel sayısı ve dağılımı,</li>
                    <li style={{fontWeight: 400}}>c) Muhasebe departmanı;</li>
                    <li style={{fontWeight: 400}}>aa) Çalışan muhasebe personel sayısı,</li>
                    <li style={{fontWeight: 400}}>bb) Muhasebe organizasyon şeması,</li>
                    <li style={{fontWeight: 400}}>cc) İdari ve muhasebe prosedürleri,</li>
                    <li style={{fontWeight: 400}}>dd) Hesap planı,</li>
                    <li style={{fontWeight: 400}}>
                        ee) Muhasebe uygulama araçlarının tespiti (elle yazım veya bilgisayar),
                    </li>
                    <li style={{fontWeight: 400}}>ff) Yönetime verilen raporlar,</li>
                    <li style={{fontWeight: 400}}>gg) İç kontrol organizasyonunun durumu.</li>
                    <li style={{fontWeight: 400}}>d) Satışlar;</li>
                    <li style={{fontWeight: 400}}>
                        aa) Satış cirosunun mamullere göre dağılımı,
                    </li>
                    <li style={{fontWeight: 400}}>bb) Satış ve tahsil metodları,</li>
                    <li style={{fontWeight: 400}}>
                        cc) Satış sözleşmeleri ile ihracat dosyalarının düzeni,
                    </li>
                    <li style={{fontWeight: 400}}>dd) Ortalama müşteri sayısı,</li>
                    <li style={{fontWeight: 400}}>
                        ee) Kendi grubuna dahil şirketlere satışlar,
                    </li>
                    <li style={{fontWeight: 400}}>e) Satın alma;</li>
                    <li style={{fontWeight: 400}}>
                        aa) Yıllık satın almanın parasal değeri,
                    </li>
                    <li style={{fontWeight: 400}}>bb) Satıcıların adet olarak miktarı,</li>
                    <li style={{fontWeight: 400}}>
                        cc) Satın alma departmanının çalışma usulü,
                    </li>
                    <li style={{fontWeight: 400}}>dd) İthalat dosyalarının düzeni,</li>
                    <li style={{fontWeight: 400}}>
                        ee) Kendi grubuna dahil şirketlerden satın almalar,
                    </li>
                    <li style={{fontWeight: 400}}>f) Envanter;</li>
                    <li style={{fontWeight: 400}}>aa) Envanter sayımı metodu,</li>
                    <li style={{fontWeight: 400}}>bb) Fiziki sayımın süresi,</li>
                    <li style={{fontWeight: 400}}>cc) Fiziki sayımın denetimi,</li>
                    <li style={{fontWeight: 400}}>g) Üretim faaliyetlerinin muhteviyatı.</li>
                    <li style={{fontWeight: 400}}>h) Maliyet sisteminin saptanması.</li>
                    <li style={{fontWeight: 400}}>i) Sabit kıymetlerin durumu;</li>
                    <li style={{fontWeight: 400}}>aa) Yıllara göre dağılımı,</li>
                    <li style={{fontWeight: 400}}>bb) Değer kayıpları,</li>
                    <li style={{fontWeight: 400}}>cc) Sayımların kontrolü,</li>
                    <li style={{fontWeight: 400}}>j) Şirket borç ve alacaklarının durumu.</li>
                    <li style={{fontWeight: 400}}>
                        k) Vergi idaresi ve diğer resmi kuruluşlarla ilişkileri.
                    </li>
                    <li style={{fontWeight: 400}}>
                        l) Son iki yıl bilanço ve kâr/zarar tablolarının fotokopileri.
                    </li>
                    <li style={{fontWeight: 400}}>m) Özel bilgiler.</li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensupları yukarıda belirtilen bilgilerin ışığında denetim ücretini,
                    denetiminin kapsamı ve planlamasını tespit ederler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Denetimin Planlaması</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 53 –</strong>&nbsp;52 nci maddede belirlenen hususlar bu
                    değerlendirmede dikkate alınarak planlama yapılır. Denetimin zaman sürecini,
                    denetimde görevlendirilecek eleman sayısını ve iş bölümünü, iç kontrol
                    organizasyonundan yararlanıp yararlanılmayacağını, denetimde ağırlık
                    verilecek hususları içeren yazılı bir denetleme programı yetkili meslek
                    mensubu tarafından hazırlanır ve çalışma dosyası açılarak denetime başlanır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Denetim Kontrolü</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 54 –</strong>&nbsp;Meslek mensupları denetimin her safhasında
                    planlama ve kontrolü etkin ve yeterli şekilde yerine getirmelidirler.
                    Denetim faaliyetinde görev alan elemanların çalışmaların yönlendirilmesi ve
                    denetimin amacına uygun bitirilmesi, denetim sorumluluğunu üstlenen meslek
                    mensubunun görevidir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Bilgi ve Belgelerin Toplanması</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 55 –</strong>&nbsp;Meslek mensubu, kurum ve kuruluşların mali
                    tablolarında yer alan; varlık, kaynak, gelir ve giderlerinin gerçeği
                    yansıtıp yansıtmadığının ve kayıtlara doğru geçirilip geçirilmediğinin
                    tespiti için gerekli bilgi ve belgeleri toplamak ve değerlendirmek amacı ile
                    aşağıdaki çalışmaları yerine getirmelidir.
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>a) Muhasebe denetimi;</li>
                    <li style={{fontWeight: 400}}>
                        aa) Muhasebede kayıt ve matematiksel hataların tespiti,
                    </li>
                    <li style={{fontWeight: 400}}>
                        bb) Muhasebe hesaplarında hata ve hilelerin tespiti,
                    </li>
                    <li style={{fontWeight: 400}}>
                        cc) Muhasebe hesaplarına intikal etmeyen kayıt dışı işlemlerin tespiti,
                    </li>
                    <li style={{fontWeight: 400}}>
                        dd) Muhasebe kayıtlarının genel kabul görmüş muhasebe prensipleri ile
                        mevzuata uygunluğunun tespiti,
                    </li>
                    <li style={{fontWeight: 400}}>
                        ee) Muhasebe yöntem ve politikalarının geçmiş yıllar ile mukayesesi ve
                        değişikliklerin nedeninin araştırılması.
                    </li>
                    <li style={{fontWeight: 400}}>b) Bilanço denetimi;</li>
                    <li style={{fontWeight: 400}}>aa) Aktif ve pasif hesapların denetimi,</li>
                    <li style={{fontWeight: 400}}>
                        bb) Dönem içi mizanlar ile hesapların bilançoya doğru yansıtılıp
                        yansıtılmadığının kontrolü,
                    </li>
                    <li style={{fontWeight: 400}}>
                        cc) Bilanço gününden önce meydana gelen ve sonradan tespit edilen
                        işlemlere ait kayıtların kontrolü,
                    </li>
                    <li style={{fontWeight: 400}}>
                        dd) Envanter işlemlerinin yapılması ve kontrolü,
                    </li>
                    <li style={{fontWeight: 400}}>ee) Kapanış kayıtlarının kontrolü.</li>
                    <li style={{fontWeight: 400}}>c) Gelir tablosunun denetimi;</li>
                    <li style={{fontWeight: 400}}>
                        aa) Hasılat ve maliyet hesapları ile randıman ve firelerin kontrolü,
                    </li>
                    <li style={{fontWeight: 400}}>
                        bb) Gelirlerle bu gelirlerin elde edilmesinde yapılan giderlerin
                        karşılaştırılması,
                    </li>
                    <li style={{fontWeight: 400}}>
                        cc) Gelir ve gider hesaplarının ilgili mevzuata uygunluğunun kontrolü.
                    </li>
                    <li style={{fontWeight: 400}}>d) Vergi Denetimi;</li>
                    <li style={{fontWeight: 400}}>
                        aa) Muhasebe belgelerinin mevzuata uygunluğu,
                    </li>
                    <li style={{fontWeight: 400}}>
                        bb) Muhasebe defterleri ve kayıtlarının mevzuata uygunluğu,
                    </li>
                    <li style={{fontWeight: 400}}>
                        cc) Muhasebe kayıtlarına geçmeyen işlemlerin ve belgelerin tespiti,
                    </li>
                    <li style={{fontWeight: 400}}>
                        dd) Aktif ve pasif hesapların değerlemelerinin mevzuata uygunluğu,
                    </li>
                    <li style={{fontWeight: 400}}>
                        ee) Alış, satış, dış ticaret, gelir ve giderlerde hata ve hilelerin
                        tespiti,
                    </li>
                    <li style={{fontWeight: 400}}>
                        ff) Vergi matrahının doğruluğunun tespiti,
                    </li>
                    <li style={{fontWeight: 400}}>
                        gg) Vergi beyannamelerinin (yıllık, münferit ve özel) mevzuata
                        uygunluğunun tespiti.
                    </li>
                    <li style={{fontWeight: 400}}>e) Tabloların mali analizleri.</li>
                    <li style={{fontWeight: 400}}>
                        f) Bilançoların muhasebe kayıtlarına uygunluğunun kontrolü.
                    </li>
                    <li style={{fontWeight: 400}}>
                        g) Bilanço kalemlerinin standart şekle uygunluğunun kontrolü.
                    </li>
                    <li style={{fontWeight: 400}}>
                        h) Dönem sonuçlarının yıllık beyannameye intikalinin mevzuata uygunluğunun
                        kontrolü.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Kurum ve kuruluşlarca istenilecek denetim hizmetlerinde yukarıda belirtilen
                    denetim ilkelerinden, ilgili olanları uygulanır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Denetim Çalışma Kâğıtları ve Çalışma Dosyası</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 56 –</strong>&nbsp;Meslek mensubu, denetimini düzenli bir
                    kayıt sistemi içinde yapmalıdır. Bu kayıt düzeni, çalışma kâğıtları ve
                    bunları toplayan çalışma dosyası ile yerine getirilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Çalışma kâğıtları; meslek mensuplarının denetleme yöntem ve teknikleri ile
                    toplanan kanıt ve değerlendirmeleri sonucu ulaşılan kanaatı ihtiva eden
                    kâğıtlar olup uygulamada kullanılması mecburidir. Ayrıca, yeminli mali
                    müşavirlerin yaptığı tasdik işlemi ile ilgili denetimlerde, resmi defterler
                    ile gerekli görülen belge ve kayıtlar tarih ve imza atılarak mühürlenir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Çalışma kâğıtlarının formu, en az aşağıdaki bilgileri ihtiva etmesi şartı
                    ile; meslek mensubunca serbestçe düzenlenebilir.
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a) Denetlenen müşteri, denetimin dönemi, hazırlandığı tarih, hazırlayan
                        meslek mensubunun adı ile sorumlu meslek mensubunun imzası yer almalıdır.
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) İleride denetim faaliyeti araştırıldığında; meslek mensubunun
                        savunmasını temin edecek şekilde; yapılan denetim çalışmalarının tüm
                        safhalarını ve sorumluluk safhalarını göstermelidir. Bir yılı kapsayan
                        denetimlerde denetimin en az her ay yapılması ve çalışma kâğıtlarının
                        aylık denetim faaliyetlerini göstermesi zorunludur.
                    </li>
                    <li style={{fontWeight: 400}}>
                        c) Hesapların tetkikinde kullanılan özel işaretlerin açıklanması, hesap
                        teyitleri, meslek mensubunun iç kontrol sisteminden yararlanıp
                        yararlanmadığı veya düşünceleri açıkça gösterilmelidir.
                    </li>
                    <li style={{fontWeight: 400}}>
                        d) Denetim programına göre denetimi yapılan hususlar ile aksayandenetim
                        faaliyeti konuları nedenleri ile belirtilmelidir.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Çalışma kâğıtları çalışma dosyası içinde on yıl süre ile yetkililerin isteği
                    ile ibraz edilmek üzere saklanmalıdır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Çalışma dosyası: Çalışma kâğıtlarının, doğruluk testlerinin, yazışmaların,
                    denetlenen kuruluşa ait mukavelelerin, talimatların, yönetim karar suretleri
                    gibi meslek mensubunun denetlenen kurum ve kuruluştan ibrazını istediği
                    belgelerin muhafaza edilmesi amacıyla kullanılan denetim dosyasıdır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Kanunsuz İşlemleri Bildirim Yükümlülüğü</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 57 –</strong>&nbsp;Meslek mensupları; mesleki sorumluluğunun
                    bilincinde, denetim faaliyeti sırasında mevzuat hükümlerine aykırı hatalı ve
                    hileli işlemleri tespit ettikleri takdirde, müşterilerine hata ve hilelerin
                    düzeltilmesini teklif ederler. Bu teklife rağmen, hata ve hilelerin
                    düzeltilmemesi halinde durum Yönetmeliğin 59. maddesinin (c) bendinde
                    belirtilen olumsuz raporla ilgili mali mercilere aksettirilir. Adli yargıya,
                    intikali gerekli olan ve suç teşkil eden hallerin yetkili mercilere
                    duyurulması mecburidir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Denetim Raporu</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 58 –</strong>&nbsp;Denetim Raporu;
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a) Genel bilgi bölümü; ilgililerin belirtildiği,
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) Denetim kapsam bölümü; dönemi belirtilen mali tabloların genel kabul
                        görmüş denetim standartlarına göre düzenlenip düzenlenmediğinin
                        belirtildiği,
                    </li>
                    <li style={{fontWeight: 400}}>
                        c) Meslek mensubunun açıklama ve görüş bölümü, denetiminin sonucunda
                        meslek mensubunda oluşan kanaatının belirtildiği,
                    </li>
                    <li style={{fontWeight: 400}}>
                        d) Rapor tarihi bölümü; denetimin bittiği tarihin gösterildiği,
                    </li>
                    <li style={{fontWeight: 400}}>
                        e) Meslek mensubunun imzası; sözleşmeyi imzalayan denetimin sorumluluğunu
                        yüklenen meslek mensubu tarafından raporun imzalandığı
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>bölümleri içerir.</p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Denetim Raporu Çeşitleri</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 59 –&nbsp;</strong>Denetim raporları meslek mensubunun denetim
                    sonucu oluşan görüşüne göre;
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a) Olumlu rapor; denetim faaliyetinin bitiminde meslek mensubunun olumlu
                        görüşünü ihtiva eden raporudur.
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) Şartlı denetim raporu; meslek mensubunun denetim sırasında karşılaştığı
                        denetim kapsamındaki sınırlamalar ile denetlenmesini istediği halleri
                        ihtiva eden rapordur.
                    </li>
                    <li style={{fontWeight: 400}}>
                        c) Olumsuz rapor; meslek mensubunun, denetim sırasında incelenen yerlerin
                        ve kuruluşların gerçek durumunu yansıtmadığı kanaatına varması sonucu
                        düzenlediği rapordur.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Denetleme Raporu ile İlgili Diğer Hususlar</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 60 –&nbsp;</strong>Serbest muhasebeci mali müşavirlerce
                    düzenlenen raporlar ile yeminli mali müşavirlerce tasdiki ihtiva etmeyen
                    raporlarda “ilgili mevzuata uygundur” ibaresi kullanılmaz. Bunun yerine
                    ilgili olan mevzuat hükümlerinin açıkça yazılması zorunludur. Bu ibare ancak
                    yeminli mali müşavirlerce tasdiki ihtiva eden raporlarda kullanılır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Tasdik işlemine bağlı olsun olmasın denetim raporlarının denetimden sorumlu
                    meslek mensubunca bizzat imzalanması esastır. İmzaları yanında meslek
                    unvanı, bağlı olduğu oda ve oda sicil kayıt numarası belirtilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>DÖRDÜNCÜ BÖLÜM</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Ruhsat Alan Meslek Mensuplarının Hak ve Ödevleri</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Haklar</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 61 –</strong>&nbsp;Ruhsat almış olan meslek mensupları bağımlı
                    veya meslek konusu dışında başka işlerde çalıştıkları, ya da mesleki
                    faaliyette bulunmadıkları hallerde;
                </p>
                <ol style={{textAlign: "justify"}}>
                    <li style={{fontWeight: 400}}>
                        a) Meslek kütüğündeki kayıtları, kanunlarında mani bir durum yoksa veya
                        kendi istekleri dışında silinemez.
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) Meslek kütüğüne kayıtlı olmaları halinde;
                    </li>
                    <li style={{fontWeight: 400}}>
                        aa) Odalar ve birliğin faaliyetlerine katılırlar,
                    </li>
                    <li style={{fontWeight: 400}}>
                        bb) Üyelikten doğan haklarını kullanırlar.
                    </li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Ödevler</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 62 –</strong>&nbsp;Ruhsat alan meslek mensupları bağımlı veya
                    meslek dışında çalıştıkları ya da mesleki faaliyette bulunmadıkları takdirde
                    unvanlarını ve tasdik yetkilerini kullanamazlar. (Değişik son
                    cümle:R.G.:21/11/2007-26707) Oda ve Birliğe karşı üyelikten doğan ödevlerini
                    yerine getirirler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>
                        Ruhsat Alan Meslek Mensuplarının Meslek Kütüğünden Silinmesi
                    </strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 63 –</strong>&nbsp;Ruhsat alan meslek mensupları aşağıdaki
                    hallerde meslek kütüğünden silinir.
                </p>
                <ol style={{textAlign: "justify"}} start={35}>
                    <li style={{fontWeight: 400}}>
                        a) Bu Yönetmeliğin 35. maddesinin b, c, d ve e bentlerinde yazılı hallere
                        göre meslek mensuplarının çalışanlar listesinden silinmesi,
                    </li>
                    <li style={{fontWeight: 400}}>
                        b) Ruhsatın herhangi bir sebeple iptal edilmesi,
                    </li>
                    <li style={{fontWeight: 400}}>c) Kendi isteği ile kaydını sildirmesi,</li>
                    <li style={{fontWeight: 400}}>d) Ölümü,</li>
                    <li style={{fontWeight: 400}}>e) Diğer sebepler.</li>
                </ol>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Yeniden müracaat edenlerden istenecek belgeler kaydın silinme nedenleri
                    dikkate alınarak ilgili odaca belirlenir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>BEŞİNCİ BÖLÜM</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Çeşitli Hükümler</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Tebliğlerle Uygulama Birliğini Sağlamak</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 64 –&nbsp; (Değişik:R.G-21/11/2007-26707)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Kanunun 2 nci maddesinde belirtilen meslekî konularla ilgili olarak
                    yapılacak çalışmalar hakkında, meslek mensupları arasında uygulama birliğini
                    sağlamak için Birlik tebliğler çıkarmak suretiyle düzenlemeler yapabilir.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 65 –</strong>&nbsp;Kanunun 2 nci maddesinin (a), (b) ve (c)
                    fıkralarında sayılan işleri, meslek mensubu unvanını kazanmaksızın birden
                    fazla müessese veya kuruluşta yapanların faaliyetleri, Kanunun 3 üncü
                    maddesinde hükme bağlanan meslek unvanlarının haksız kullanılması sayılır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Geçici Maddeler</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Geçici Madde 1 –</strong>&nbsp;Çalışmaları Maliye ve Gümrük
                    Bakanlığı dışındaki Bakanlık, kurum ve kuruluşlarca düzenlenen bağımsız
                    denetleme kuruluşları ve denetçiler 30/06/1990 tarihine kadar Kanun ve bu
                    Yönetmelik hükümlerine göre gerekli düzenlemeleri yapmaları halinde mesleki
                    faaliyetlerine devam edebilirler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Geçici Madde 2 –</strong>&nbsp;Bu Yönetmeliğin yürürlüğe girdiği
                    tarihe kadar, serbest muhasebeci ve serbest mali müşavir gibi çeşitli
                    sıfatlarla Kanunun 2 nci maddesinde belirtilen mesleki faaliyetlerde bulunan
                    kişiler Geçici Kurul’dan izin almadıkça; kuruluşlar ise Kanun ve bu
                    Yönetmelik hükümlerine göre ortaklık bürosu veya şirket olarak çalışmak
                    üzere gerekli düzenlemeleri yapmadıkça 01/01/1990 tarihinden itibaren hiçbir
                    mesleki faaliyette bulunamazlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Geçici Madde 3 –</strong>&nbsp;Birlik kurulup, Yönetmeliği
                    yayınlanıncaya kadar, bu Yönetmelik hükümleri uygulanır.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Geçici Madde&nbsp; 4 –&nbsp; (Ek:R.G-21/11/2007-26707)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Bu Yönetmeliğin yayımlandığı tarihte faaliyette bulunan şirketlerden daha
                    önce ortaklık yapısındaki değişiklikleri bildirmeyenler, Yönetmeliğin
                    yayımlandığı tarihten itibaren üç ay içinde değişikliğin yapıldığı Türkiye
                    Ticaret Sicili Gazetesinin aslını bir dilekçe ekinde bağlı oldukları odalara
                    vermek zorundadırlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensupları, bu Yönetmelikle yapılan düzenlemelere, Yönetmeliğin
                    yayımı tarihinden itibaren bir yıl içinde durumlarını uygun hale getirmek
                    zorundadırlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Geçici Madde 5 –</strong>&nbsp;
                    <strong>(Ek:RG-22/5/2015-29363)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Meslek mensupları halen kullanmakta oldukları tabelaları bu Yönetmeliğin
                    yürürlük tarihinden itibaren bir yıl içerisinde 15 inci maddeye uygun hale
                    getirmekle yükümlüdürler.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Geçici Madde 6 –</strong>&nbsp;
                    <strong>(Ek:RG-22/5/2015-29363)</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    Serbest Muhasebeci unvanıyla görev yapan mevcut meslek mensupları ile
                    Serbest Muhasebecilik stajına devam edenlerden stajını başarı ile
                    bitirenler, Kanunun 2 nci maddesinin (A) fıkrasının (a) bendinde belirtilen
                    işleri yaparlar ve bu Yönetmelikte yer alan hükümlere tabi olurlar.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Yürürlük</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 66 –</strong>&nbsp;Geçici Kurul tarafından hazırlanan bu
                    Yönetmelik yayımı tarihinde yürürlüğe girer.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Yürütme</strong>
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <strong>Madde 67 –</strong>&nbsp;Bu Yönetmelik hükümlerini&nbsp;
                    <strong>(Değişik ibare:RG-22/5/2015-29363)&nbsp;</strong>
                    <u>Maliye Bakanı</u>&nbsp;yürütür.
                </p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>__________</p>
                <p style={{fontWeight: 400, textAlign: "justify"}}>
                    <sup>(1)</sup>&nbsp;<em>Bu yönetmeliğin adı “</em>Serbest Muhasebeci,
                    Serbest Muhasebeci Mali Müşavir ve Yeminli Mali Müşavirlerin Çalışma Usul ve
                    Esasları Hakkında Yönetmeliğin adı “Serbest Muhasebeci Mali Müşavir ve
                    Yeminli Mali Müşavirlerin Çalışma Usul ve Esasları Hakkında Yönetmeliği
                    <em>
                        ” iken 22/5/2015 tarihli ve 29363sayılı Resmi Gazete’de yayımlanan
                        “Serbest Muhasebeci, Serbest Muhasebeci Mali Müşavir ve Yeminli Mali
                        Müşavirlerin Çalışma usul ve Esasları Hakkında Yönetmelikte&nbsp;
                    </em>
                    Değişiklik Yapılmasına Dair Yönetmelik
                    <em>” ile metne işlendiği biçimde değiştirilmiştir.</em>
                </p>
            </div>
        </Container>
    );
};

export default Mevzuat;
